export default "__VITE_ASSET__MIxcYMKb__"